'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomImage from '@components/CustomImage';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxBlock from '@components/ParallaxBlock';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';

export default function WestminsterTowerResidences(
  props: MarketingPageComponentProps
) {
  const section = props?.locale?.section || {};

  const propertyButton = section?.['westminsterTowerHomePropertyButton'] || {};

  return (
    <Stack
      component="section"
      className={cn.westminsterTowerResidences}
      sx={{
        backgroundImage: `url(${props?.images?.westminster_tower_dark_background?.src || ''})`,
      }}
    >
      <Box className={cn.westminsterResidencesInner}>
        <Box className={cn.westminsterResidencesBlock}>
          <Box component="picture" className={cn.westminsterResidencesLeft}>
            <ParallaxBlock
              className={cn.westminsterResidencesTheme}
              animationType="zoomIn"
              animationDuration={500}
            >
              <CustomImage
                src={props?.images?.westminster_tower_home_graphics?.src || ''}
                alt="Westminster Tower Home Graphics"
                width={768}
                height={768}
              />
            </ParallaxBlock>
          </Box>

          <Box component="picture" className={cn.westminsterResidencesRight}>
            <Box className={cn.westminsterResidencesRight__header}>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  section?.westminsterTowerHomePropertyHeading || ''
                )}
              </ParallaxText>
            </Box>

            <Box className={cn.westminsterResidencesRight__content}>
              <ParallaxText
                variant="p"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  section?.westminsterTowerHomePropertyContent || ''
                )}
              </ParallaxText>
            </Box>

            <Box className={cn.westminsterResidencesRight__button}>
              <DynamicButton
                showLink={true}
                className={cn.westminsterResidencesButton}
                url={propertyButton?.link || ''}
                linkLabel={propertyButton?.label || 'View'}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
